import { Slider, SliderThumb, Box, styled } from "@mui/material";

const ProgressSlider = styled(Slider)({
  color: "transparent",
  padding: 0,
  pointerEvents: "none",
  "& .MuiSlider-track": {
    height: 0,
  },
  "& .MuiSlider-rail": {
    height: 0,
  },
  "& .MuiSlider-thumb": {
    height: 25,
    width: 4,
    backgroundColor: "white",
    border: "1px solid black",
    borderRadius: "1px",
    pointerEvents: "all",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
    "&::after": {
      display: "none",
    },
  },
});

type ThumbComponentProps = React.HTMLAttributes<unknown>;

function ThumbComponent(props: ThumbComponentProps) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <Box
        sx={{
          position: "absolute",
          top: "-20px",
          height: "20px",
          width: "20px",
          background: "white",
          borderRadius: "50%",
          border: "2px solid #239B8B",
        }}
      ></Box>
    </SliderThumb>
  );
}

interface TSCurrentTimeRefProps {
  value: number;
  handleProgressRefSeek: (event: Event, value: number | number[], activeThumb: number) => void;
  // handleProgressRefMouseDown: React.MouseEventHandler<HTMLSpanElement>;
  // handleProgressRefMouseUp: (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]) => void;
}

const TSCurrentTimeRef = ({
  value,
  handleProgressRefSeek,
}: // handleProgressRefMouseDown,
// handleProgressRefMouseUp,
TSCurrentTimeRefProps) => (
  <ProgressSlider
    sx={{ position: "absolute", top: "13px", left: 0, width: "100%" }}
    min={0}
    max={100}
    value={value}
    valueLabelDisplay="off"
    onChange={handleProgressRefSeek}
    // onMouseDown={handleProgressRefMouseDown}
    // onChangeCommitted={handleProgressRefMouseUp}
    components={{
      Thumb: ThumbComponent,
    }}
  />
);

export default TSCurrentTimeRef;
